import Button from '@/components/Button';
import { TbClipboardCopy, IoMdCloudDownload } from '@/components/react-icons/main';
import copyToClipboard from '@/lib/copyToClipboard';
import * as Popover from '@radix-ui/react-popover';
import { useState } from 'react';

const RetryStackPopover = ({ children, retryStack = [], side = 'bottom', align = 'start', sideOffset = 4, className = '', disabled = false }) => {
  const [open, setOpen] = useState(false);

  const handleOpenChange = (isOpen) => {
    if (disabled) {
      return;
    }
    setOpen(isOpen);
  };

  const handleCopyCurl = (curl) => {
    if (!curl) {
      return;
    }
    const sanitizedCurl = curl.replace(/--data '({[\s\S]*?})'/g, (match, body) => {
      return `--data '${body.replace(/'/g, "'\\''")}'`;
    });
    copyToClipboard(sanitizedCurl, { toast: true });
  };

  const handleDownloadJson = (retry) => {
    const data = retry?.meta?.response || retry?.data?.[0];
    if (!data) {
      return;
    }
    const jsonString = JSON.stringify(data, null, 2);
    const blob = new Blob([jsonString], { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `retry-attempt-${retryStack.indexOf(retry) + 1}.json`;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  if (!retryStack || retryStack.length === 0) {
    return children;
  }

  return (
    <Popover.Root open={open} onOpenChange={handleOpenChange}>
      <Popover.Trigger asChild disabled={disabled}>
        {children}
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content className="retry-stack-popover-content" side={side} align={align} sideOffset={sideOffset}>
          <div className="retry-stack-popover-wrapper">
            <div className="retry-stack-popover-header">Retry Attempts</div>
            <div className="retry-stack-popover-list">
              {retryStack.map((retry, index) => {
                const status = retry?.meta?.response?.status;
                const statusText = retry?.meta?.response?.statusText;
                const curl = retry?.meta?.curl;
                const attemptNumber = index + 1;

                return (
                  <div key={index} className="retry-stack-popover-item">
                    <div className="retry-stack-popover-item-title">Attempt {attemptNumber}</div>
                    <div className="retry-stack-popover-item-footer">
                      {status !== undefined && (
                        <div className={`retry-stack-popover-item-status ${status >= 400 ? 'error' : 'success'}`}>
                          {status} {statusText}
                        </div>
                      )}
                      <div className="retry-stack-popover-item-actions">
                        {(retry?.meta?.response || retry?.data?.[0]) && <Button className="ghost" icon={IoMdCloudDownload} onClick={() => handleDownloadJson(retry)} size="sm" title="Download as JSON" />}
                        {curl && <Button className="ghost" icon={TbClipboardCopy} onClick={() => handleCopyCurl(curl)} size="sm" title="Copy cURL" />}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};

export default RetryStackPopover;
